var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.3125C5.87512 1.3125 4.7755 1.64607 3.8402 2.27102C2.90489 2.89597 2.17591 3.78423 1.74544 4.82349C1.31496 5.86274 1.20233 7.00631 1.42179 8.10958C1.64124 9.21284 2.18292 10.2263 2.97833 11.0217C3.77374 11.8171 4.78716 12.3588 5.89043 12.5782C6.99369 12.7977 8.13726 12.685 9.17652 12.2546C10.2158 11.8241 11.104 11.0951 11.729 10.1598C12.3539 9.2245 12.6875 8.12488 12.6875 7C12.686 5.49206 12.0862 4.04631 11.02 2.98004C9.95369 1.91376 8.50795 1.31404 7 1.3125ZM9.05917 9.05917C8.97714 9.1411 8.86594 9.18712 8.75 9.18712C8.63407 9.18712 8.52287 9.1411 8.44084 9.05917L6.69084 7.30917C6.60877 7.2272 6.56261 7.11599 6.5625 7V3.5C6.5625 3.38397 6.6086 3.27269 6.69064 3.19064C6.77269 3.10859 6.88397 3.0625 7 3.0625C7.11604 3.0625 7.22731 3.10859 7.30936 3.19064C7.39141 3.27269 7.4375 3.38397 7.4375 3.5V6.81917L9.05917 8.44083C9.1411 8.52287 9.18712 8.63406 9.18712 8.75C9.18712 8.86594 9.1411 8.97714 9.05917 9.05917Z",
    fill: "#DA3333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderPendingIcon);
export default __webpack_public_path__ + "static/media/OrderPendingIcon.8c01afcb41a78124509cc5abbc46c65d.svg";
export { ForwardRef as ReactComponent };